import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import { getImgURL, getDesignation, getStringJoinByDash, abbreviateNumber } from '@shared-submodule/utils'
import noImage from '@assets/images/placeholder/person-placeholder.png'
import styles from './style.module.scss'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import CustomLink from '@shared/components/customLink'

const MyImage = dynamic(() => import('@shared/components/myImage'))

function AuthorDetailLink({ slug, children, className }) {
  return (
    <CustomLink href={slug} prefetch={false}>
      <a className={className}>{children}</a>
    </CustomLink>
  )
}

AuthorDetailLink.propTypes = {
  slug: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
}

function AuthorListCard({ data }) {
  const authorListItemID = data?.oSeo?.sSlug || getStringJoinByDash(data?.sFName)
  return (
    <AuthorDetailLink slug={allRoutes.authorDetail(data?.oSeo?.sSlug)}>
      <article id={authorListItemID} className={`${styles.authorListCard} mb-3`}>
        <div className={`${styles.postimg}`}>
          <MyImage
            src={getImgURL(data?.sUrl) || noImage}
            alt={`Author ${data?.sFName}`}
            placeholder="blur"
            width={100}
            height={100}
            blurDataURL={BLUR_DATA_URL_BASE64}
            layout="responsive"
          />
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column align-items-center">
            <h4 className={`mb-1 text-capitalize ${styles.authorName} w-100`}>
              <div className={`d-flex align-items-center justify-content-center text-center ${styles.authorName}`}>
                <span className={`${styles.title} overflow-hidden text-nowrap d-block`}>{data?.sFName}</span>
                {data?.bIsVerified && (
                  <span className={`${styles.verfied} rounded-circle flex-shrink-0`} />
                )}
              </div>
            </h4>
            <span className={`${styles.designation} text-muted medium-text mb-2 d-block`}>{getDesignation(data.eDesignation)}</span>
            <Row className="gx-2 mt-1 text-muted xsmall-text justify-content-between">
              <Col className={`d-flex gap-md-1 text-nowrap ${styles.authorCardFooterText}`}>
                <p className='mb-0'>{data?.nArticleCount}</p>
                <p className='mb-0'>{'posts'}</p>
              </Col>
              <Col className={`d-flex gap-md-1 text-nowrap ${styles.authorCardFooterText}`}>
                <p className='mb-0'>{abbreviateNumber(data?.nViewCount || 0)}</p>
                <p className='mb-0'>{'reads'}</p>
              </Col>
            </Row>
          </div>
        </div>
      </article>
    </AuthorDetailLink >
  )
}

AuthorListCard.propTypes = {
  data: PropTypes.object
}

AuthorListCard.defaultProps = {
  data: {}
}

export default AuthorListCard
